module.exports = "query GetAppBySlug($appId: String!) {\n  getAppBySlug(id: $appId){\n    id\n    name\n    slug\n  }\n}\n\n"